export enum LevelSelectionType {
  ACTIVATION = 'activation',
  MANUAL_CHANGE = 'manual_change',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/level-selection-type.ts